import PropTypes from 'prop-types'
import { useEffect } from 'react'
import Preview from 'features/creative/preview/Preview'
import TextInput from 'components/form/TextInput'
import LandingUrl from 'features/creative/add/common/LandingUrl'
import { useDispatch, useSelector } from 'react-redux'
import {
  isFilledLink,
  reset,
  setIndividualChecked,
  setMobileUrl,
  setPcUrl,
  setText,
} from 'features/creative/add/asset/additionalLinkSlice'
import ErrorText from 'components/form/ErrorText'
import { formSatisfied } from 'features/creative/creativeUtil'
import useChannelLandingUrlPolicy from 'features/creative/add/common/useChannalLandingUrlPolicy'
import Button from 'components/form/Button'
import { inactiveAsset } from 'features/creative/add/build/buildCreativeSlice'

const AdditionalLink = ({ disabled, errors, imported }) => {
  const dispatch = useDispatch()
  const { links } = useSelector(state => state.creative.assets.additionalLink)

  useEffect(
    () => () => {
      dispatch(reset())
    },
    [dispatch]
  )

  const satisfied = formSatisfied(3, links, isFilledLink)

  return (
    <div className="cont_material">
      <div className="group_material">
        <div className="box_material">
          <strong className="subtit_subject2">
            텍스트형 &gt; 부가링크
            <Button
              size="small"
              disabled={disabled}
              onClick={() => {
                dispatch(inactiveAsset('additionalLink'))
              }}>
              삭제
            </Button>
          </strong>
          <AdditionalLinkItem
            index={0}
            errors={errors}
            disabled={disabled}
            imported={imported}
            required
          />
          <AdditionalLinkItem
            index={1}
            errors={errors}
            disabled={disabled}
            imported={imported}
            required
          />
          <AdditionalLinkItem
            index={2}
            errors={errors}
            disabled={disabled}
            imported={imported}
            required
          />
          <AdditionalLinkItem
            index={3}
            errors={errors}
            disabled={disabled || !satisfied}
            imported={imported}
          />
        </div>
        <Preview type="ADDITIONAL_LINK" data={{ links }} />
      </div>
    </div>
  )
}

const AdditionalLinkItem = ({
  index,
  required,
  disabled,
  errors,
  imported,
}) => {
  const dispatch = useDispatch()
  const { links } = useSelector(state => state.creative.assets.additionalLink)
  const {
    text,
    landingUrl: { individual, mobileUrl, pcUrl },
  } = links[index]
  const error = errors?.links[index]

  useChannelLandingUrlPolicy(
    v =>
      setIndividualChecked({
        index,
        checked: v,
      }),
    disabled,
    imported
  )

  const onChangeIndividual = checked => {
    dispatch(
      setIndividualChecked({
        index,
        checked,
      })
    )
  }
  const onChangeMobileUrl = url => {
    dispatch(
      setMobileUrl({
        index,
        url,
      })
    )
  }
  const onChangePcUrl = url => {
    dispatch(
      setPcUrl({
        index,
        url,
      })
    )
  }
  const onChangeText = v => {
    dispatch(
      setText({
        index,
        text: v,
      })
    )
  }

  return (
    <div className="inner_material">
      <div className="material_item">
        <div className="tit_itemwrap">
          <strong className="tit_item">
            내용{index + 1}
            {required && <span className="fc_warn">*</span>}
          </strong>
        </div>
        <div className="desc_item">
          <TextInput
            value={text}
            trim
            onValueChange={onChangeText}
            placeholder="내용을 입력하세요"
            maxLength={6}
            disabled={disabled}
            error={error?.text}
          />
          <ErrorText error={error?.text} />
        </div>
      </div>
      <LandingUrl
        title={`랜딩 URL${index + 1}`}
        individual={individual}
        mobileUrl={mobileUrl}
        pcUrl={pcUrl}
        onChangeIndividual={onChangeIndividual}
        onChangeMobileUrl={onChangeMobileUrl}
        onChangePcUrl={onChangePcUrl}
        disabled={disabled}
        errors={{
          mobileUrl: error?.mobileUrl,
          pcUrl: error?.pcUrl,
        }}
      />
    </div>
  )
}

export default AdditionalLink

AdditionalLinkItem.propTypes = {
  index: PropTypes.number.isRequired,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  errors: PropTypes.shape({
    text: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    mobileUrl: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    pcUrl: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    links: PropTypes.arrayOf(
      PropTypes.shape({
        text: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
        mobileUrl: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
        pcUrl: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
      })
    ),
  }),
  imported: PropTypes.bool,
}

AdditionalLink.propTypes = {
  disabled: PropTypes.bool.isRequired,
  errors: PropTypes.object,
  imported: PropTypes.bool,
}
